import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import styled, { css } from 'styled-components'

const secondary = css`
  border: 1px double ${({ theme }) => theme.palette.blue20};
  background: ${({ theme }) => theme.palette.blue20};
  color: ${({ theme }) => theme.colors.brandSecondaryContrast};
`

export const DatepickerAdvancedWrapper = styled.div`
  .DateInput_input {
    font-size: ${({ theme }) => theme.fontSize.xs};
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
    padding: ${({ theme }) => theme.space.xs};
  }
  .DateInput_input__focused {
    border-bottom: 2px solid ${({ theme }) => theme.colors.brandPrimary};
  }
  .DateInput {
    width: auto;
  }
  .DateRangePickerInput_arrow_svg {
    width: 20px;
  }
  .CalendarMonth_caption {
    font-size: ${({ theme }) => theme.fontSize.sm};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    margin-bottom: ${({ theme }) => theme.space.xs};
    padding-top: ${({ theme }) => theme.space.md};
    color: ${({ theme }) => theme.colors.text00};
  }
  .DayPickerNavigation_button__horizontalDefault {
    background: none;
    line-height: 1.7rem;
    text-align: center;
    position: absolute;
    padding: 0;
    border: 0.45rem solid transparent;
    z-index: 1;
    height: 10px;
    width: 10px;
    text-indent: -999em;
    overflow: hidden;
  }
  .DayPickerNavigation_leftButton__horizontalDefault {
    border-right-color: rgb(0, 79, 239);
    left: 15px;
  }
  .DayPickerNavigation_rightButton__horizontalDefault {
    border-left-color: ${({ theme }) => theme.colors.brandPrimary};
    right: 15px;
  }
  .DayPicker_weekHeader {
    top: 50px;
    color: ${({ theme }) => theme.colors.text00};
  }
  .CalendarDay {
    vertical-align: middle;
    transition: 0.4s;
  }
  .CalendarDay__selected,
  .CalendarDay__hovered_start_first_possible_end {
    border-radius: 0;
    background: ${({ theme }) => theme.colors.brandPrimary};
    min-width: ${({ theme }) => theme.layout.sm};
    box-shadow:
      inset 0 0 0 2px ${({ theme }) => theme.colors.brandPrimary},
      inset 0 0 0 3px white;
    border: 1px double ${({ theme }) => theme.colors.brandPrimary};
    &:hover {
      ${secondary}
    }
  }

  .CalendarDay__selected_span {
    ${secondary}
    &:hover {
      ${secondary};
    }
  }
  .CalendarDay__hovered_span,
  .CalendarDay__default:hover {
    ${secondary};
    background: ${({ theme }) => theme.palette.blue30};
  }
`
